'use strict';

var util = angular.module('gymsystem.util');

util.controller('StorageSetting', ['$scope', '$http', 'fileManager', 'Setting', 'alertProvider',
    function($scope, $http, fileManager, Setting, alertProvider) {

    $scope.prev = $scope.data = {};

    var hash = (function() {
        var keys = ['storage_type', 'fake_s3_host', 'fake_s3_port', 'fake_link'];
        return function(d) {
            return keys.map(function(key) {return d[key];}).join(',');
        };
    })();

    $scope.isChanged = function() {
        return hash($scope.data) != hash($scope.prev);
    };

    Setting.get('Storage').then(function(data) {
        $scope.data = data;
        $scope.prev = _.clone(data);
    });

    $http.get('/api/utils/file/get_stats').success(function(response) {
        $scope.stats = response;

        var names = {
            0: 'Local storage',
            1: 'Amazon S3',
            2: 'Fake S3',
            3: 'Old storage',
            4: 'S3 Frankfurt',
            5: 'Link',
            6: 'DB'
        };
        response.group.forEach(function(row) {
            row.storageName = names[row.storage];
        });
    });

    $scope.save = function() {
        $scope.loading = true;
        Setting.set('Storage', {
            storage_type: Number($scope.data.storage_type),
            fake_s3_host: $scope.data.fake_s3_host || '',
            fake_s3_port: Number($scope.data.fake_s3_port || 0),
            fake_link: $scope.data.fake_link || ''
        }).then(function() {
            $scope.prev = _.clone($scope.data);
            alertProvider.show('success', 'Settings saved');
            $scope.loading = false;
        }, function() {
            alertProvider.show('error', 'Failed to save settings');
            $scope.loading = false;
        });
    };

}]);
